import React from 'react'
import useCurrentUser from '../../../hooks/use-current-user'
import List from './list'

const SystemSettingsList = () => {

    const { isAdmin } = useCurrentUser()

    if (!isAdmin) {
        return null
    }

    return (
        <List />
    )
}

export default SystemSettingsList